import "./ValidateSignup.scss";
import CountdownTimer from "../../components/countdownTimer/CountdownTimer";
import {
  CustomLoadingButton,
} from "../../components/ui/CustomButton";
import newRequest from "../../utils/newRequest";
import { motion } from "framer-motion";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DOMPurify from 'dompurify';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { customSelectStyles_dark, customSelectStyles_light } from "../../components/ui/CustomSelect";
import Select from "react-select";
import { ScaleLoader } from "react-spinners";

const ValidateSignup = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const [signupData, setSignupData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const parts = location.pathname.split("/");
  const signup_docid = parts[parts.length - 1];
  const [fullName, setFullName] = useState("");
  const [orgName, setOrgName] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [financialStartDate, setFinancialStartDate] = useState(null);
  const [orgNameError, setOrgNameError] = useState("");
  const [fullNameError, setFullNameError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [dateError, setDateError] = useState("");
  const [tacError, setTacError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showVerifyPassword, setShowVerifyPassword] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countries, setCountries] = useState([]);
  const fullNameRef = useRef(null);
  const [defaultView, setDefaultView] = useState("subscribe");

  // default to 1st Jan
  useEffect(() => {
    // Set default value to the first day of the current year
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    const formattedDate = moment(firstDayOfYear).format("YYYY-MM-DD");
    setFinancialStartDate(formattedDate);
  }, []);

  const fetchSignupDetails = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.get(`/q/getSignup/${signup_docid}`);
      if (res.data) {
        // console.log(`/q/getSignup ${JSON.stringify(res.data, null, 2)}`);
        setSignupData(res.data);

        if (res.data?.su_completed) {
          setDefaultView("linkUsed");
          setIsLoading(false);
          return;
        }
        const now = new Date().getTime();
        const targetTime = new Date(res.data?.su_expire).getTime();
        const timeDifference = targetTime - now;
        // console.log(`timeDifference ${JSON.stringify(timeDifference, null, 2)}`);
        if (timeDifference <= 0) {
          setDefaultView("linkExpired");
          setIsLoading(false);
          return;
        }
      }
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };


  const fetchSupportedCountries = async () => {
    try {
      const res = await newRequest.get("/sub/countries");
      setCountries(res.data);
      // detect country
      await fetch('https://ipapi.co/json/')
        .then(res => res.json())
        .then(data => {
          // console.log("User Country:", data.country_name);
          console.log("country:", data.country_code);
          if (data.country_code) {
            setSelectedCountry({
              value: data.country_code.toLowerCase(),
              label: data.country_name
            })
          }
        })
        .catch(err => console.error("Geolocation error:", err));
      // console.log(`country  ${JSON.stringify(country, null, 2)}`);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    try {
      fetchSignupDetails();
      fetchSupportedCountries();
      if (fullNameRef.current) {
        fullNameRef.current?.focus();
      }
    } catch (error) {
      console.log(error);
    }
  }, [signup_docid]);

  const handleCompleteSignup = async () => {
    try {
      let errorOccured = "N";
      setFullNameError("");
      setOrgNameError("");
      setDateError("");
      setTacError("");
      setPasswordError("");

      if (!fullName) {
        setFullNameError("Please enter your name");
        errorOccured = "Y";
      }

      if (!orgName) {
        setOrgNameError("Organization Name is Mandatory");
        errorOccured = "Y";
      }

      if (!selectedCountry?.value) {
        setCountryError("Please select country");
        errorOccured = "Y";
      }

      if (!financialStartDate) {
        setDateError("Your Must select financial period start date");
        errorOccured = "Y";
      }

      if (password?.length < 5) {
        setPasswordError("Password must be at least 6 Characters");
        errorOccured = "Y";
      }

      if (password !== verifyPassword) {
        setPasswordError("Passwords do not match");
        errorOccured = "Y";
      }

      if (errorOccured === "Y") {
        return;
      }

      const formattedDate = moment(financialStartDate).format("YYYY-MM-DD");
      const res = await newRequest.post(
        "/org/sub",
        {
          org_name: orgName,
          person_full_name: fullName,
          signup_docid: signup_docid,
          year_start_date: formattedDate,
          country: selectedCountry?.value,
          password: password,
        }
      );
      // console.log(`/org/sub  ${JSON.stringify(res.data, null, 2)}`);
      if (res.data === "Subscribed") {
        setDefaultView("allSet");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="validate-signup">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <>
          {defaultView === "subscribe" && (
            <motion.div
              className="wrapper"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h1 className="title">FINISH SIGNUP</h1>
                <span>
                  <h1 style={{ cursor: "pointer" }} onClick={() => {
                    try {
                      navigate("/bima")
                    } catch (error) {
                      console.log(error)
                    }
                  }}>{t('appName')}</h1>
                </span>
              </div>
              <form>
                <h1>{`Welcome Back ${signupData?.su_email}`}</h1>
                <CountdownTimer targetDate={signupData?.su_expire} />
                <div
                  className="input-item-with-label"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                  }}
                >
                  {/* <label
                htmlFor="full_name"
                style={{
                  width: "max-content",
                }}
              >
                YOUR NAME
              </label> */}
                  <input
                    ref={fullNameRef}
                    id="full_name"
                    name="full_name"
                    type="text"
                    placeholder="YOUR NAME"
                    value={fullName}
                    className="form-input-item"
                    style={{ width: "400px" }}
                    onChange={(e) => {
                      try {
                        setFullName(e.target.value);
                        if (e.target.value) {
                          if (e.target.value.length > 2) {
                            setFullNameError("");
                          }
                        }
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  />
                </div>
                {fullNameError && <span className="error">{fullNameError}</span>}
                <div
                  className="input-item-with-label"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "5px",
                  }}
                >
                  {/* <label
                htmlFor="full_name"
                style={{
                  width: "max-content",
                }}
              >
                ORGANIZATION NAME
              </label> */}
                  <input
                    id="org_name"
                    name="org_name"
                    type="text"
                    placeholder="ORGANIZATION"
                    value={orgName}
                    className="form-input-item"
                    style={{ width: "400px" }}
                    onChange={(e) => {
                      try {
                        setOrgName(e.target.value);
                        if (e.target.value) {
                          if (e.target.value.length > 2) {
                            setOrgNameError("");
                          }
                        }
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  />
                </div>
                {orgNameError && <span className="error">{orgNameError}</span>}
                <div className="input-item-with-label" style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                }}>
                  {/* <label htmlFor="cond_type" style={{ width: "max-content" }}>{t('type').toUpperCase()}</label> */}
                  <Select
                    id="country"
                    name="country"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="400px"
                    value={countries.find((option) => option.value === selectedCountry?.value) || null}
                    onChange={(selectedOption) => setSelectedCountry(selectedOption)}
                    options={countries}
                    isSearchable={true}
                    placeholder={t('country').toUpperCase()}
                  />
                </div>
                {countryError && <span className="error">{countryError}</span>}
                <div
                  className="input-item-with-label"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <label
                    htmlFor="full_name"
                    style={{
                      width: "max-content",
                    }}
                  >
                    FINANCIAL YEAR START DATE
                  </label>
                  <input
                    id="financialStartDate"
                    name="financialStartDate"
                    type="date"
                    value={financialStartDate}
                    className="form-input-item"
                    style={{ width: "200px" }}
                    onChange={(e) => {
                      try {
                        const formattedDate = moment(e.target.value).format(
                          "YYYY-MM-DD"
                        );
                        setFinancialStartDate(formattedDate);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  />
                  {dateError && <span className="error">{dateError}</span>}
                </div>
                {/* password fields */}
                <label
                  htmlFor="pw-layout"
                  style={{
                    width: "max-content",
                    marginTop: "10px",
                  }}
                >
                  SET YOUR PASSWORD
                </label>
                <div
                  id="pw-layout"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <div className="input-item-with-label" style={{ position: "relative" }}>
                    <input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="PASSWORD"
                      value={password}
                      className="form-input-item"
                      style={{ width: "200px", paddingRight: "30px" }}
                      onChange={(e) => {
                        try {
                          setPassword(e.target.value);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      onBlur={(e) => {
                        try {
                          if (e.target.value.length < 5) {
                            setPasswordError("Password must be at least 6 Characters");
                          } else {
                            setPasswordError("");
                          }
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                      }}
                    >
                      {showPassword ? <IoEyeOff size={20} /> : <IoEye size={20} />}
                    </span>
                  </div>
                  <div className="input-item-with-label" style={{ position: "relative" }}>
                    <input
                      id="verifyPassword"
                      name="verifyPassword"
                      type={showVerifyPassword ? "text" : "password"}
                      placeholder="VERIFY"
                      value={verifyPassword}
                      className="form-input-item"
                      style={{ width: "200px", paddingRight: "30px" }}
                      onChange={(e) => {
                        try {
                          setVerifyPassword(e.target.value);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      onBlur={(e) => {
                        try {
                          if (e.target.value !== password) {
                            setPasswordError("Passwords do not match");
                          } else {
                            setPasswordError("");
                          }
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    />
                    <span
                      onClick={() => setShowVerifyPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                      }}
                    >
                      {showVerifyPassword ? <IoEyeOff size={20} /> : <IoEye size={20} />}
                    </span>
                  </div>
                </div>

                {passwordError && <span className="error">{passwordError}</span>}

                <CustomLoadingButton
                  currentTheme={currentTheme}
                  height={"40px"}
                  width={"250px"}
                  onClick={handleCompleteSignup}
                >
                  {t('finish')}
                </CustomLoadingButton>
              </form>
            </motion.div>
          )}
          {defaultView === "allSet" && (
            <motion.div
              className="landing-section"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <motion.div
                className="hero-text"
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: 1,
                }}
                exit={{
                  opacity: 0,
                }}
              >
                <h1>
                  You are all set <span>Wonderful</span>
                </h1>
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`Click the button below to log in and start securing your growth. <b>Your username is ${signupData.su_email}</b> and password is the one you have entered. We are exited to work with you!`) }} />
                <CustomLoadingButton
                  height={"45px"}
                  width={"200px"}
                  onClick={() => {
                    try {
                      navigate("/login");
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  LOGIN
                </CustomLoadingButton>
              </motion.div>
            </motion.div>
          )}
          {defaultView === "linkUsed" && (
            <motion.div
              className="landing-section"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <h1 style={{ marginBottom: "10px" }}>
                This Link has already been used to signup.
              </h1>
              <p style={{ marginBottom: "10px" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`If you started the signup process and you do not know who completed it, please get in touch with us immediately!`) }} />
              <CustomLoadingButton
                height={"45px"}
                width={"200px"}
                onClick={() => {
                  try {
                    navigate("/");
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Home
              </CustomLoadingButton>
            </motion.div>
          )}
          {defaultView === "linkExpired" && (
            <motion.div
              className="landing-section"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <h1 style={{ marginBottom: "10px" }}>
                This Link has expired. Please signup again
              </h1>
              <CustomLoadingButton
                height={"45px"}
                width={"200px"}
                onClick={() => {
                  try {
                    navigate("/");
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Home
              </CustomLoadingButton>
            </motion.div>
          )}
        </>
      )}
    </div>
  );
};

export default ValidateSignup;
